// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/pagecontainer/components/chatinterface/components/chatbody/index.scss
// module id = 2512
// module chunks = 13